import 'react-native-url-polyfill/auto'

// UNCOMMENT IF TOO MANY CONSOLE LOGS ARE MAKING YOU SAD DURING LOCAL DEVELOPMENT
// import '@/lib/filterConsole'

import {
  Poppins_100Thin,
  Poppins_200ExtraLight,
  Poppins_300Light,
  Poppins_400Regular,
  Poppins_500Medium,
  Poppins_600SemiBold,
  Poppins_700Bold,
  Poppins_800ExtraBold,
  Poppins_900Black,
  useFonts
} from '@expo-google-fonts/poppins'
import { clsx } from 'clsx'
import { SplashScreen, usePathname } from 'expo-router'
import Head from 'expo-router/head'
import { useCallback, useEffect } from 'react'
import { SystemBars } from 'react-native-edge-to-edge'

import { BrandOffsetGradientView, StackNavigator, VStack } from '@/components'
import { useStackScreenOptions } from '@/hooks'
import { requestTrackingPermissionsAsync } from '@/lib'
import { Providers } from '@/providers'

// this is the global nativewind/tailwind css that has all the classnames used in the app. the ugly route is necessary,
// because this file must live at the root of the workspace to be able to load tailwind properly
import '../../global.css'

// tell the splash screen to not hide automatically, we'll do it manually when the UI is ready
SplashScreen.preventAutoHideAsync().catch(console.warn)

// expo-router only wraps a route in an error boundary if that route exports one. without this, any
// uncaught render error anywhere in the tree -- a Relay query erroring out (relay throws those during
// render), a null ref, a runaway state update -- terminates the app in release builds instead of
// rendering a recoverable screen. see DBY-460.
export { ErrorBoundary } from 'expo-router'

// eslint-disable-next-line react/display-name
export default () => {
  const screenOptions = useStackScreenOptions()
  const pathname = usePathname()
  // load up our UI fonts
  const [fontsLoaded, fontsError] = useFonts({
    Poppins_100Thin,
    Poppins_200ExtraLight,
    Poppins_300Light,
    Poppins_400Regular,
    Poppins_500Medium,
    Poppins_600SemiBold,
    Poppins_700Bold,
    Poppins_800ExtraBold,
    Poppins_900Black
  })
  const init = useCallback(async () => {
    await SplashScreen.hideAsync()
    await requestTrackingPermissionsAsync()
  }, [])

  // Expo Router uses Error Boundaries to catch errors in the navigation tree.
  useEffect(() => {
    if (fontsError) {
      throw fontsError
    }
  }, [fontsError])

  useEffect(() => {
    if (fontsLoaded) {
      init().catch(console.error)
    }
  }, [init, fontsLoaded])

  if (!fontsLoaded) {
    return null
  }

  return (
    <Providers>
      <Head>
        <title>Dateability: Disabled Dating</title>
      </Head>
      <SystemBars style='light' />
      <BrandOffsetGradientView>
        <VStack
          className={clsx(
            'flex-1',
            // don't constrain the user redirect/splash screen
            pathname !== '/' &&
              // limit the overall app to be the size of a 1024px wide screen, and center that. if we are 1024px wide or
              // larger, show left/right borders to visually indicate the constraint
              'w-full max-w-screen-lg self-center lg:border-r-[0.5px] lg:border-r-brand-purple-500/40'
          )}
        >
          <StackNavigator
            screenOptions={{
              ...screenOptions,
              animation: 'fade',
              cardOverlayEnabled: false,
              cardShadowEnabled: false,
              detachPreviousScreen: true,
              freezeOnBlur: true,
              headerShown: false
            }}
          >
            <StackNavigator.Screen name='index' />
            <StackNavigator.Screen name='onboarding' />
            <StackNavigator.Screen name='(auth)' />
            <StackNavigator.Screen name='(user)' />
          </StackNavigator>
        </VStack>
      </BrandOffsetGradientView>
    </Providers>
  )
}
